import {
  ComponentRef,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  Renderer2,
  ViewContainerRef,
  inject,
} from '@angular/core';
import {
  HoverStateComponent,
  PriceGradePopupData,
} from './hover-state.component';
import { Subscription, debounceTime, fromEvent, map } from 'rxjs';

/* 
  Directive to show the hover state popup when hovering over a calendar date
*/
@Directive({
  selector: '[ssTicketingCalendarHoverState]',
  standalone: true,
})
export class HoverStateDirective implements OnDestroy {
  private view = inject(ViewContainerRef);
  private elementRef = inject(ElementRef);
  private renderer = inject(Renderer2);

  /* selector is the same name as the input aso all you need to do is
  use the selector with the object eg: [ssTicketingCalendarHoverState]="priceGradePopupData" */
  @Input() ssTicketingCalendarHoverState!: PriceGradePopupData;
  private scrollingEvent = fromEvent(window, 'scroll').pipe(
    debounceTime(100),
    map(() => this.setPopupLocation())
  );
  private scrollingSubscription: Subscription | undefined;
  private popup: ComponentRef<HoverStateComponent> | undefined;

  @HostListener('mouseenter') onMouseEnter() {
    if (!this.popup && !this.ssTicketingCalendarHoverState.hide) {
      this.popup = this.view.createComponent(HoverStateComponent);
      this.popup.instance.priceGradeData = this.ssTicketingCalendarHoverState;
      this.setPopupLocation();
      this.renderer.appendChild(
        this.elementRef.nativeElement,
        this.popup.location.nativeElement
      );
      this.scrollingSubscription = this.scrollingEvent.subscribe();
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.popup) {
      this.popup.destroy();
      this.popup = undefined;
      this.scrollingSubscription?.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.scrollingSubscription?.unsubscribe();
  }

  private setPopupLocation() {
    if (this.popup) {
      this.popup.instance.priceGradeData = this.ssTicketingCalendarHoverState;
      const { left, top } =
        this.elementRef.nativeElement.getBoundingClientRect();
      this.popup.instance.left = left - 50;
      this.popup.instance.top = top;
      this.popup.changeDetectorRef.markForCheck();
    }
  }
}
